// src/components/SopFaqs.jsx
import React, { useState } from "react";
import SOPFaqHindi from "../../../PDF/SOP _FAQs_ GrievanceRedressal_Mutual Funds_September_2025 _Hindi.pdf"
import SOPFaqEnglish from "../../../PDF/SOP_FAQs_GrievanceRedressal_Mutual Funds_September_2025 _English.pdf"
import "../UnclaimedDividendHistory/UnclaimedDividendHistory.css";

function SopFaqs() {
  const [subTab, setSubTab] = useState("english");

  const handleSubTabChange = (event, newValue) => {
    setSubTab(newValue);
  };

  return (
    <div>
      <h2>SOP / FAQs for Unclaimed Amounts</h2>

      {/* Sub-tabs */}
      {/* <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
        <TabContext value={subTab}>
          <TabList
            onChange={handleSubTabChange}
            aria-label="SOP/FAQs Sub Tabs"
          >
            <Tab
              label="SOP_FAQs_GrievanceRedressal_Mutual Funds_September_2025 _English"
              value="english"
            />
            <Tab
              label="SOP_FAQs_GrievanceRedressal_Mutual Funds_September_2025 _Hindi"
              value="hindi"
            />
          </TabList>

          <TabPanel value="english">
            <Link
              href={SOPFaqEnglish}
              target="_blank"
              rel="noopener"
              underline="hover"
            >
              Open English SOP / FAQs PDF
            </Link>
          </TabPanel>

          <TabPanel value="hindi">
            <Link
              href={SOPFaqHindi}
              target="_blank"
              rel="noopener"
              underline="hover"
            >
              Open Hindi SOP / FAQs PDF
            </Link>
          </TabPanel>
        </TabContext>
      </Box> */}

      <div className="forms-container">
        <div className="forms">
          <div className="form-items">
            <div className="blue-box">
              <a href={SOPFaqEnglish} target="_blank" rel="noreferrer">
                SOP_FAQs_GrievanceRedressal_September_2025  (English)
              </a>
            </div>
            <div className="blue-box">
              <a href={SOPFaqHindi} target="_blank" rel="noreferrer">
                SOP _FAQs_ GrievanceRedressal_September_2025  (Hindi)
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SopFaqs;
